import { Tooltip } from '@nextui-org/react'
import { format } from 'date-fns'
import { FC, memo } from 'react'
import { Handle, Position } from 'reactflow'
import { ThemeConfig } from './config'

type HandleData = {
  handleId: string
  type: string
  position: string
  shift?: number
}

type TankNodeType = {
  data: {
    tankName: string
    startDate: string
    endDate: string | null
    handles: HandleData[]
    width: number
    height: number
  }
}
type PositionKey = 'right' | 'left' | 'top' | 'bottom'

const PositionDict: Record<PositionKey, Position> = {
  right: Position.Right,
  left: Position.Left,
  top: Position.Top,
  bottom: Position.Bottom,
}

const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return ''
  try {
    // Handle ISO 8601 format (e.g., "2024-03-14T15:00:00.000Z")
    const date = new Date(dateStr)
    if (isNaN(date.getTime())) return dateStr
    return format(date, 'yyyy-MM-dd')
  } catch {
    return dateStr
  }
}

const TankNodeComponent: FC<TankNodeType> = ({ data }) => {

  return (
    <div className="text-updater-node" data-testid={`tank-node-${data.tankName}`}>
      <Tooltip
        className="bg-opacity-50"
        content={
          <div className="px-1 py-2">
            <div className="font-bold text-small">Tank Name: {data.tankName}</div>
            <div className="font-bold text-small">
              Start Date: {formatDate(data.startDate)}
            </div>
            <div className="font-bold text-small">
              End Date: {formatDate(data.endDate)}
            </div>
          </div>
        }
        placement="top"
        closeDelay={0}
        disableAnimation={true}
      >
        <div
          key={data.tankName}
          style={{ width: data.width, height: data.height, padding: 0 }}
          data-testid={`tank-content-${data.tankName}`}
        >
          <span>{data.tankName}</span>
        </div>
      </Tooltip>
      {data.handles.map((handle) => (
        <Handle
          key={handle.handleId}
          id={handle.handleId}
          type={handle.type === 'source' ? 'source' : 'target'}
          position={PositionDict[handle.position as PositionKey]}
          style={
            handle.shift && (handle.position === 'top' || handle.position === 'bottom')
              ? { left: handle.shift * ThemeConfig.unitSize * ThemeConfig.widthSize }
              : {}
          }
        />
      ))}
    </div>
  )
}

TankNodeComponent.displayName = 'TankNodeComponent'

export const TankNode = memo(TankNodeComponent)
